import React from 'react';
import {
  ClipboardList,
  Clock,
  Bell,
  Construction,
} from 'lucide-react';

const SurveysPage = () => {
  return (
    <div className="animate-stagger">
      {/* Header */}
      <div className="mb-8">
        <h1 className="text-2xl font-bold text-text-primary mb-2">Encuestas y Feedback</h1>
        <p className="text-text-secondary">
          Participa en las encuestas internas y ayuda a mejorar Sonneil
        </p>
      </div>

      {/* Coming Soon Card */}
      <div className="card p-12 text-center border-2 border-dashed border-warning/40">
        <div className="w-20 h-20 rounded-full bg-warning/10 flex items-center justify-center mx-auto mb-6">
          <Construction size={40} className="text-warning" />
        </div>
        
        <h2 className="text-2xl font-bold text-text-primary mb-3">
          Próximamente en funcionamiento
        </h2>
        
        <p className="text-text-secondary max-w-md mx-auto mb-8">
          Estamos trabajando en el módulo de encuestas internas. Pronto podrás participar 
          en encuestas, dar feedback y ayudarnos a mejorar Sonneil.
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 max-w-2xl mx-auto">
          <div className="p-4 bg-background rounded-xl">
            <ClipboardList size={24} className="text-primary mx-auto mb-2" />
            <h4 className="font-medium text-text-primary text-sm">Crear encuestas</h4>
            <p className="text-xs text-text-tertiary mt-1">Encuestas internas personalizadas</p>
          </div>
          
          <div className="p-4 bg-background rounded-xl">
            <Bell size={24} className="text-primary mx-auto mb-2" />
            <h4 className="font-medium text-text-primary text-sm">Notificaciones</h4>
            <p className="text-xs text-text-tertiary mt-1">Alertas de nuevas encuestas</p>
          </div>
          
          <div className="p-4 bg-background rounded-xl">
            <Clock size={24} className="text-primary mx-auto mb-2" />
            <h4 className="font-medium text-text-primary text-sm">Historial</h4>
            <p className="text-xs text-text-tertiary mt-1">Ver encuestas completadas</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SurveysPage;
